<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal">
      <div class="modal-header__container">
        <h2 class="modal-header__h2">Вход</h2>
      </div>

      <!-- ЗАМЕНА: div -> form, добавлен @submit.prevent -->
      <form class="modal-middle__form" @submit.prevent="handleLogin">
        <div class="form-group">
          <input
            id="email"
            v-model="email"
            type="email"
            required
            class="modal-middle__input"
            placeholder="Введите почту"
          />
        </div>

        <div class="form-group">
          <input
            id="password"
            v-model="password"
            type="password"
            required
            class="modal-middle__input"
            placeholder="Введите пароль"
          />
        </div>

        <p v-if="error" class="error">{{ error }}</p>

        <div class="modal-footer">
          <a class="forgot__a" @click="forgotPassword">
            Забыли пароль?
          </a>
        </div>

        <div class="submit-button__container">
          <!-- кнопка уже type="submit", теперь будет срабатывать при Enter -->
          <button class="submit__button" type="submit" :disabled="loading">
            {{ loading ? "Входим..." : "Войти" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"

export default {
  name: "LoginModal",
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      email: "",
      password: ""
    }
  },
  computed: {
    ...mapState("user", ["loading", "error"])
  },
  methods: {
    ...mapActions("user", ["login"]),
    async handleLogin() {
      try {
        await this.login({ email: this.email, password: this.password })
        this.close()
      } catch (e) {
        console.error("Ошибка входа:", e)
      }
    },
    forgotPassword() {
      alert("Переход к восстановлению пароля")
    },
    close() {
      this.$emit("close")
    }
  }
}
</script>

<style scoped>
/* ваш CSS без изменений */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal {
  background: var(--grey-1);
  padding: 1rem;
  border-radius: 0.5rem;
  width: 350px;
  max-width: 90%;
}
.form-group {
  margin-bottom: 1rem;
}
.error {
  color: red;
  margin-bottom: 1rem;
}
.modal-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}
.modal-header__container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  position: relative;
  padding-bottom: 1rem;
  border-bottom: 0.1rem solid var(--grey-0);
}
.profile-modal__close {
  background: transparent;
  padding: 0;
  color: white;
  position: absolute;
  right: 0;
}
.profile-modal__close:hover {
  opacity: 0.5
}
.modal-header__h2 {
  font-size: 1.5rem;
  line-height: 1;
}
.submit__button {
  margin-left: auto;
}
.forgot__a {
  text-decoration: underline;
  color: var(--blue-0);
  text-align: left;
  cursor: pointer;
}
.submit-button__container {
  padding-top: 1rem;
  border-top: 0.1rem solid var(--grey-0);
  margin-top: 1rem;
}
.submit__button:hover {
  opacity: 0.8
}
.modal-middle__form {
  margin-top: 1rem;
}
.modal-middle__input {
  border: 0.1rem solid var(--grey-0);
  transition: 0.3s ease all;
}
.modal-middle__input:focus {
  border: 0.1rem solid var(--blue-0);
}
</style>
